import React from 'react';
import './Bookmark.css';
import Section from '../common/Section';

export default function Bookmark() {
  return (
    <Section title="[ BOOKMARKS ]" link="/bookmarks" contentClassName="bookmark-content">
    </Section>
  );
}
